import { useEffect, useState } from 'react';

import { optimizely as optimizelyInstance } from '@shared/v2/contexts/optimizely';

type Flags = {
  [key: string]: {
    variation: string | null;
    rule: string | null;
  };
};

type DataLayer = {
  optimizelyEvent: (flags: Flags) => void;
};

type UseOptimizelyAnalyticsParams = {
  featureFlagsForAnalytics: string[];
  dataLayer: DataLayer;
};

const useOptimizelyAnalytics = ({
  featureFlagsForAnalytics,
  dataLayer,
}: UseOptimizelyAnalyticsParams) => {
  const [hasLogged, setHasLogged] = useState(false);

  useEffect(() => {
    if (
      !optimizelyInstance ||
      hasLogged ||
      featureFlagsForAnalytics?.length < 1
    ) {
      return;
    }

    optimizelyInstance.onReady().then(() => {
      try {
        const allDecisions = optimizelyInstance.decideForKeys(
          featureFlagsForAnalytics,
        );

        const flags: Flags = {};

        Object.entries(allDecisions).forEach(([key, decision]) => {
          flags[key] = {
            variation: decision.variationKey,
            rule: decision.ruleKey,
          };
        });

        if (Object.keys(flags).length > 0) {
          dataLayer.optimizelyEvent(flags);
        }

        setHasLogged(true);
      } catch (error) {
        console.error('Error - Optimizely Analytics', error);
      }
    });
  }, [dataLayer, featureFlagsForAnalytics, hasLogged]);
};

export default useOptimizelyAnalytics;
